<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<mat-toolbar class="toolbar mat-elevation-z0">
  <mat-toolbar-row class="title">
    <div *ngIf="partnerId !== lenovoPartner; else lenovoPartnerLogo" class="img-banner">
      <img class="cigent-logo" src="assets/Cigent_Logo_Light_R.webp" alt="Cigent Logo" />
      <img class="cigent-box" src="assets/cigent-box.jpg" alt="Generic Cigent image" />
    </div>
    <ng-template #lenovoPartnerLogo>
    <div *ngIf="partnerId === lenovoPartner" class="img-banner">
      <div class="lenovo-logo-wrapper">
        <span class="lenovo-logo"></span>
        <div>
          <span class="data-defense">
            Data Defense <span class="powered-by-cigent">powered by Cigent</span>
          </span>
        </div>
      </div>
      <img class="cigent-box" src="assets/cigent-box.jpg" alt="Digital art" />
    </div>
    </ng-template>
  </mat-toolbar-row>
</mat-toolbar>
<mat-card appearance="raised" class="card-container mat-elevation-z1" *ngIf="invitationResponse && errorFindingInvitation === false; else invitationError">
  <mat-card-content *ngIf="invitationResponse.expired === false; else invitationExpired">
    
    <app-password 
      mode="INVITATION" 
      [invitationUUID]="invitationUUID"
      [showBestPractices]="false"
      [email]="invitationResponse.email">
    </app-password>

  </mat-card-content>
  <ng-template #invitationExpired>
    <mat-card-content>
      {{fExpired}}<a routerLink="/reset">{{fHere}}</a>.
    </mat-card-content>
  </ng-template>
</mat-card>
<ng-template #invitationError>
  <mat-card appearance="raised" class="card-container mat-elevation-z1">
    <mat-card-content>
      {{fNotFound}}<a routerLink="/reset">{{fHere}}</a>.
    </mat-card-content>
  </mat-card>
</ng-template>
